export default {
    medicalScientificDegrees: 'درجه علمی',
    medicalScientificDegreesTitle: 'عنوان',
    medicalScientificDegreesStatus: 'وضعیت',
    editMedicalScientificDegrees: 'ویرایش درجه علمی ',
    addMedicalScientificDegrees: 'درجه علمی جدید',
}